export default {
    tag: {
        code: {
            font: {
                weight: "{font.weight.regular}"
            },
            color: "{surface.950}",
            background: "{tag.secondary.background}"
        },
        height: "1.375rem"
    },
    Code: "Fira Code",
    card: {
        border: {
            color: "{content.border.color}"
        }
    },
    chip: {
        border: {
            color: "{chip.color}",
            style: "solid",
            width: "1px"
        }
    },
    font: {
        size: {
            xl: "1.5rem",
            xxl: "2rem",
            large: "1.125rem",
            small: "0.75rem",
            medium: "0.875rem"
        },
        family: {
            standard: "Proxima Nova"
        },
        weight: {
            bold: "700",
            medium: "500",
            regular: "400",
            semibold: "600"
        },
        decoration: {
            underline: "underline"
        },
        lineHeight: {
            xl: "2rem",
            xxl: "2.25rem",
            large: "1.5rem",
            small: "1rem",
            medium: "1.25rem"
        }
    },
    icon: {
        large: {
            size: "1.125rem"
        },
        small: {
            size: "0.875rem"
        },
        medium: {
            size: "1rem"
        },
        xLarge: {
            size: "1.375rem"
        },
        xSmall: {
            size: "10px"
        }
    },
    link: {
        gap: "0.25rem",
        color: "{primary.color}",
        focus: {
            ring: {
                color: "{primary.color}"
            }
        },
        hover: {
            color: "{primary.800}"
        },
        active: {
            color: "{primary.900}"
        },
        border: {
            radius: "{border.radius.round}"
        }
    },
    navy: {
        50: "#FAFAFF",
        100: "#EBEEFF",
        200: "#D2D7F2",
        300: "#BABFDD",
        400: "#A6AABF",
        500: "#8F93A9",
        600: "#797F9F",
        700: "#6872A6",
        800: "#232C61",
        900: "#121B50",
        950: "#141938"
    },
    text: {
        link: {
            fontSize: "{font.size.medium}",
            fontFamily: "{font.family.standard}",
            fontWeight: "{font.weight.regular}",
            lineHeight: "100%",
            textDecoration: "{font.decoration.underline}"
        },
        bodyItalic: {
            fontSize: "{font.size.medium}",
            fontFamily: "{font.family.standard}",
            fontWeight: "Italic",
            lineHeight: "{font.lineHeight.medium}"
        },
        bodyRegular: {
            fontSize: "{font.size.medium}",
            fontFamily: "{font.family.standard}",
            fontWeight: "{font.weight.regular}",
            lineHeight: "{font.lineHeight.medium}"
        },
        bodySemibold: {
            fontSize: "{font.size.medium}",
            fontFamily: "{font.family.standard}",
            fontWeight: "{font.weight.semibold}",
            lineHeight: "{font.lineHeight.medium}"
        },
        headerPrimary: {
            fontSize: "{font.size.xxl}",
            fontFamily: "{font.family.standard}",
            fontWeight: "{font.weight.regular}",
            lineHeight: "{font.lineHeight.xxl}"
        },
        headerSecondary: {
            fontSize: "{font.size.xl}",
            fontFamily: "{font.family.standard}",
            fontWeight: "{font.weight.regular}",
            lineHeight: "{font.lineHeight.xl}"
        },
        metadataRegular: {
            fontSize: "{font.size.small}",
            fontFamily: "{font.family.standard}",
            fontWeight: "{font.weight.regular}",
            lineHeight: "{font.lineHeight.small}"
        },
        headerTertiaryRegular: {
            fontSize: "{font.size.large}",
            fontFamily: "{font.family.standard}",
            fontWeight: "{font.weight.regular}",
            lineHeight: "{font.lineHeight.large}"
        },
        headerTertiarySemibold: {
            fontSize: "{font.size.large}",
            fontFamily: "{font.family.standard}",
            fontWeight: "{font.weight.semibold}",
            lineHeight: "{font.lineHeight.large}"
        }
    },
    black: "#141A1F",
    brand: {
        50: "#F2F9FC",
        100: "#D3ECF8",
        200: "#B4E2F7",
        300: "#70C3E9",
        400: "#26A3DD",
        500: "#1F9CD6",
        600: "#1A89C9",
        700: "#0F7BBA",
        800: "#036BB5",
        900: "#025C9D",
        950: "#014170"
    },
    chart: {
        color: {
            dark: {
                1: "{brand.800}",
                2: "{pink.900}",
                3: "{teal.800}"
            },
            gray: "{gray.400}",
            light: {
                1: "{purple.500}",
                2: "{orange.600}",
                3: "{green.600}"
            }
        }
    },
    white: "#ffffff",
    avatar: {
        lg: {
            border: {
                color: "{avatar.color}",
                style: "solid",
                width: "3px"
            }
        },
        sm: {
            font: {
                size: "0.75rem"
            },
            icon: {
                size: "0.75rem"
            },
            group: {
                offset: "-0.5rem"
            },
            width: "1.5rem",
            border: {
                color: "{avatar.color}",
                style: "solid",
                width: "1px"
            },
            height: "1.5rem"
        },
        med: {
            border: {
                color: "{avatar.color}",
                style: "solid",
                width: "2px"
            }
        }
    },
    border: {
        radius: {
            round: "100px"
        }
    },
    button: {
        text: {
            primary: {
                disabled: {
                    color: "{button.disabled.color}",
                    border: "{button.disabled.border}",
                    background: "{button.disabled.background}"
                }
            },
            secondary: {
                disabled: {
                    color: "{gray.300}",
                    border: "{button.disabled.border}",
                    background: "{button.disabled.background}"
                }
            }
        },
        danger: {
            disabled: {
                color: "{button.disabled.color}",
                border: "{button.disabled.border}",
                background: "{button.disabled.background}"
            }
        },
        primary: {
            disabled: {
                color: "{button.disabled.color}",
                border: "{button.disabled.border}",
                background: "{button.disabled.background}"
            }
        },
        disabled: {
            color: "{surface.600}",
            border: "{surface.300}",
            background: "{surface.100}"
        },
        outlined: {
            primary: {
                disabled: {
                    color: "{button.disabled.color}",
                    border: "{button.disabled.border}",
                    background: "{button.disabled.background}"
                },
                background: "{content.background}"
            },
            secondary: {
                disabled: {
                    color: "{button.disabled.color}",
                    border: "{button.disabled.border}",
                    background: "{button.disabled.background}"
                }
            }
        }
    },
    margin: {
        0: "0px",
        1: "8px",
        2: "16px",
        3: "24px",
        4: "32px",
        5: "40px",
        xs: "0.25rem",
        large: "1rem",
        small: "0.5rem",
        medium: "0.875rem",
        buttons: "0.75rem"
    },
    select: {
        gap: {
            x: "8px",
            y: "3px"
        }
    },
    padding: {
        body: "0.5rem",
        header1: "1.125rem",
        header2: "1rem",
        header3: "0.875rem",
        metadata: "0.25rem"
    },
    sideNav: {
        item: {
            icon: {
                color: "{surface.500}",
                hover: {
                    color: "{surface.600}"
                },
                active: {
                    color: "{brand.950}"
                }
            },
            color: "{surface.800}",
            hover: {
                color: "{surface.900}",
                background: "{surface.100}"
            },
            active: {
                color: "{brand.950}",
                border: {
                    color: "{primary.color}"
                },
                background: "{brand.100}"
            },
            level1: {
                active: {
                    hover: {
                        border: "{surface.600}",
                        background: "{brand.200}"
                    },
                    border: "{surface.500}"
                },
                expanded: {
                    icon: "{surface.600}",
                    color: "{surface.900}",
                    hover: {
                        background: "{surface.200}"
                    },
                    background: "{surface.100}"
                }
            },
            level2: {
                active: {
                    hover: {
                        border: "{surface.600}"
                    },
                    border: "{surface.500}"
                },
                expanded: {
                    icon: "{surface.600}",
                    color: "{surface.900}",
                    hover: {
                        icon: "{surface.700}",
                        color: "{surface.950}",
                        background: "{surface.300}"
                    },
                    background: "{surface.200}"
                }
            },
            background: "{surface.0}"
        },
        border: {
            color: "{content.border.color}"
        },
        expanded: {
            width: "15rem"
        },
        collapsed: {
            width: "3.5rem"
        },
        background: "{content.background}"
    },
    carousel: {
        item: {
            border: {
                radius: "{content.border.radius}"
            }
        }
    },
    checkbox: {
        label: {
            padding: "{form.field.padding.x}"
        }
    },
    dataview: {
        card: {
            border: {
                radius: "{content.border.radius}"
            }
        }
    },
    inputText: {
        gap: {
            x: "8px",
            y: "3px"
        }
    },
    paginator: {
        nav: {
            button: {
                disabled: "{button.text.secondary.disabled.color}"
            }
        }
    },
    breadcrumb: {
        last: {
            icon: {
                color: "{text.muted.color}"
            },
            item: {
                color: "{text.muted.color}"
            }
        }
    },
    breakpoint: {
        large: "1440px",
        small: "768px",
        medium: "1024px",
        xSmall: "320px"
    },
    datepicker: {
        today: {
            border: {
                color: "{primary.color}"
            }
        },
        disabled: {
            color: "{text.muted.color}"
        }
    },
    metergroup: {
        data: {
            gray: "{chart.color.gray}",
            color: {
                dark: {
                    1: "{chart.color.dark.1}",
                    2: "{chart.color.dark.2}",
                    3: "{chart.color.dark.3}"
                },
                light: {
                    1: "{chart.color.light.1}",
                    2: "{chart.color.light.2}",
                    3: "{chart.color.light.3}"
                }
            }
        }
    },
    mobileText: {
        link: {
            fontSize: "{font.size.medium}",
            fontFamily: "{font.family.standard}",
            fontWeight: "{font.weight.regular}",
            lineHeight: "100%",
            textDecoration: "{font.decoration.underline}"
        },
        bodyItalic: {
            fontSize: "{font.size.medium}",
            fontFamily: "{font.family.standard}",
            fontWeight: "Italic",
            lineHeight: "{font.lineHeight.medium}"
        },
        bodyRegular: {
            fontSize: "{font.size.medium}",
            fontFamily: "{font.family.standard}",
            fontWeight: "{font.weight.regular}",
            lineHeight: "{font.lineHeight.medium}"
        },
        bodySemibold: {
            fontSize: "{font.size.medium}",
            fontFamily: "{font.family.standard}",
            fontWeight: "{font.weight.semibold}",
            lineHeight: "{font.lineHeight.medium}"
        },
        headerPrimary: {
            fontSize: "{font.size.xl}",
            fontFamily: "{font.family.standard}",
            fontWeight: "{font.weight.regular}",
            lineHeight: "{font.lineHeight.xl}"
        },
        headerSecondary: {
            fontSize: "{font.size.large}",
            fontFamily: "{font.family.standard}",
            fontWeight: "{font.weight.regular}",
            lineHeight: "{font.lineHeight.large}"
        },
        metadataRegular: {
            fontSize: "{font.size.small}",
            fontFamily: "{font.family.standard}",
            fontWeight: "{font.weight.regular}",
            lineHeight: "{font.lineHeight.small}"
        },
        headerTertiaryRegular: {
            fontSize: "{font.size.medium}",
            fontFamily: "{font.family.standard}",
            fontWeight: "{font.weight.regular}",
            lineHeight: "{font.lineHeight.large}"
        },
        headerTertiarySemibold: {
            fontSize: "{font.size.medium}",
            fontFamily: "{font.family.standard}",
            fontWeight: "{font.weight.semibold}",
            lineHeight: "{font.lineHeight.large}"
        }
    },
    navigation: {
        border: {
            color: "{content.border.color}"
        },
        background: "{content.background}"
    },
    transition: {
        duration: {
            lg: "0.3s",
            md: "0.2s",
            sm: "0.15s",
            xl: "0.4s",
            xs: "0.12s",
            xxl: "0.5s",
            xxs: "0.1s"
        }
    },
    multiselect: {
        gap: {
            x: "8px",
            y: "3px"
        }
    },
    transparent: "#ffffff00",
    autocomplete: {
        gap: {
            x: "8px",
            y: "3px"
        }
    },
    globalHeader: {
        logo: {
            slot: "14.0625rem"
        },
        border: {
            color: "{navigation.border.color}"
        },
        navitem: {
            gap: "0.75rem",
            color: "{text.color}",
            active: {
                color: "{primary.color}"
            },
            padding: {
                x: "0.75rem",
                y: "1.4375rem"
            },
            underline: {
                color: "{surface.300}"
            }
        },
        padding: {
            x: "1rem"
        },
        useractionsitem: {
            gap: "0.5rem",
            color: "{button.text.secondary.color}",
            active: {
                color: "{primary.color}"
            },
            padding: {
                x: "0.25rem",
                y: "1.5625rem"
            },
            underline: {
                color: "{surface.300}"
            }
        },
        useractionsmenu: {
            padding: {
                x: "0.75rem",
                y: "0.75rem"
            }
        }
    },
    toggleswitch: {
        label: {
            padding: "8px"
        },
        handle: {
            checked: {
                disabled: {
                    color: "{form.field.disabled.background}"
                }
            }
        },
        checked: {
            disabled: {
                background: "{form.field.disabled.color}"
            }
        }
    },
    bulkactionbar: {
        border: {
            color: "{primary.600}"
        },
        background: "{primary.50}"
    }
}